import type { SelectedItemRenderProps } from '@openx/components-core/lib/SelectionDrawer/types.ts';
import type { ListCountriesQuery } from '../../../../../../../../graphql/fragment/audiences/ListCountries.generated.tsx';
import type { ListRegionsQuery } from '../../../../../../../../graphql/fragment/audiences/ListRegions.generated.tsx';
import type { FormSegment, LookalikeFormSegment } from '../../../../../types.ts';
import type { LookalikeDefinitionSegments } from '../hooks/lookalike/lookalikeSegmentsReducer.ts';
import { SelectedLookalikeItem } from './SelectedSegmentsList/SelectedLookalikeItem.tsx';
import { SelectedSegmentItem as OriginalSelectedSegmentItem } from './SelectedSegmentsList/SelectedSegmentItem.tsx';

type SelectedSegmentItemProps = SelectedItemRenderProps<FormSegment | LookalikeDefinitionSegments> & {
  onEditLookalike?: (segment: LookalikeFormSegment) => void;
  regions: ListRegionsQuery['region'];
  countries: ListCountriesQuery['country'];
};

const isLookalikeDefinition = (item: unknown): item is LookalikeDefinitionSegments => {
  return typeof item === 'object' && item !== null && ('similaritySegment' in item || 'seedSegment' in item);
};

const isFormSegment = (item: FormSegment | LookalikeDefinitionSegments): item is FormSegment => {
  return !isLookalikeDefinition(item);
};

export const SelectedSegmentItemAdapter = ({
  item,
  onRemove,
  onEditLookalike,
  regions,
  countries,
}: SelectedSegmentItemProps) => {
  if (isLookalikeDefinition(item)) {
    return (
      <SelectedLookalikeItem definition={item} onRemove={() => onRemove(item)} onEditLookalike={onEditLookalike} />
    );
  }

  if (isFormSegment(item)) {
    return (
      <OriginalSelectedSegmentItem
        segment={item}
        onRemove={() => onRemove(item)}
        regions={regions}
        countries={countries}
      />
    );
  }

  return null;
};
